<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-unit size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Product Unit</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-unit" centered title="New Product Unit" title-class="font-18" hide-footer>
          <div class="app-modal-banner">
            <div class="app-modal-banner-icon">
              <i class="mdi mdi-package-variant-plus"></i>
            </div>
            <div class="app-modal-banner-copy">
              <div class="app-modal-banner-title">Create a new unit</div>
              <div class="app-modal-banner-sub">
                Hover the <i class="mdi mdi-information-outline"></i> next to any field to see what it means.
              </div>
            </div>
          </div>
          <form @submit.prevent="addUnit">
              <div class="form-group mb-2">
              <label class="field-label" for="unit-input-name">
                <span>Name</span>
                <i class="mdi mdi-information-outline help-icon" id="unit-help-name" tabindex="0"></i>
              </label>
              <b-popover id="popover-unit-name" target="unit-help-name" triggers="hover focus" placement="right" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Name</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-unit-name')">
                      <i class="mdi mdi-close"></i>
                    </button>
                  </div>
                </template>
                Enter the pack or measurement unit name &mdash; for example <strong>tablet</strong>, <strong>strip</strong>, <strong>vial</strong>, <strong>bottle</strong>, or <strong>box</strong>. This unit is what staff will choose when configuring product pricing and stock conversions.
              </b-popover>
              <input id="unit-input-name" v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-unit')" :disabled="unitSaving" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="unitSaving" >
                    <b-spinner v-if="unitSaving" small class="align-middle me-1"></b-spinner>
                    <i v-else class="fas fa-check-circle"></i>
                    {{ unitSaving ? 'Saving...' : 'Submit' }}
                  </b-button>
              </div>
          </form>
      </b-modal>

      <b-modal id="edit-unit" centered title="Edit Product Unit" title-class="font-14" hide-footer>
          <div class="app-modal-banner">
            <div class="app-modal-banner-icon">
              <i class="mdi mdi-package-variant"></i>
            </div>
            <div class="app-modal-banner-copy">
              <div class="app-modal-banner-title">Update this unit</div>
              <div class="app-modal-banner-sub">
                Hover the <i class="mdi mdi-information-outline"></i> next to any field to see what it means.
              </div>
            </div>
          </div>
          <form @submit.prevent="editUnit">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label class="field-label" for="unit-input-edit-name">
                <span>Unit Name</span>
                <i class="mdi mdi-information-outline help-icon" id="unit-help-edit-name" tabindex="0"></i>
              </label>
              <b-popover id="popover-unit-edit-name" target="unit-help-edit-name" triggers="hover focus" placement="right" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Unit Name</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-unit-edit-name')">
                      <i class="mdi mdi-close"></i>
                    </button>
                  </div>
                </template>
                Update the pack or measurement unit name. Renaming a unit here changes it across all products that already use it, so make sure the new name still describes the same physical pack.
              </b-popover>
              <input id="unit-input-edit-name" v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-unit')" :disabled="unitEditSaving" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="unitEditSaving" >
                    <b-spinner v-if="unitEditSaving" small class="align-middle me-1"></b-spinner>
                    <i v-else class="fas fa-check-circle"></i>
                    {{ unitEditSaving ? 'Saving...' : 'Submit' }}
                  </b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-unit" centered title="Delete Product Unit" title-class="font-18" hide-footer>
          <form @submit.prevent="removeUnit">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the Unit : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-unit')" :disabled="unitDeleteSaving" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="unitDeleteSaving" >
                    <b-spinner v-if="unitDeleteSaving" small class="align-middle me-1"></b-spinner>
                    <i v-else class="fas fa-check-circle"></i>
                    {{ unitDeleteSaving ? 'Deleting...' : 'YES' }}
                  </b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { unitsMethods, unitsComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Product Units",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        title: "Product Units",
        items: [ {text: "Dashboard",to: "/",}, {text: "Product Units",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'addedby', label: 'Added by', visible: true },
            { key: 'addedon', label: 'Added on', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',
        unitSaving:false,
        unitEditSaving:false,
        unitDeleteSaving:false,
      };
    },
    computed: {
      ...unitsComputed,
      List() { return this.productunits.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.productunits.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.productunits.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchUnits();
      this.TotalRows = this.productunits.length;
      this.isBusy=false;
      document.addEventListener("click", this.handleOutsideHelpClick);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleOutsideHelpClick);
    },
    methods: {
      ...unitsMethods,
      closeHelp(popoverId) {
        this.$root.$emit("bv::hide::popover", popoverId);
      },
      closeAllHelp() {
        this.$root.$emit("bv::hide::popover");
      },
      handleOutsideHelpClick(event) {
        const target = event.target;
        if (!target || !target.closest) return;
        if (target.closest(".help-icon") || target.closest(".app-help-popover")) {
          return;
        }
        this.closeAllHelp();
      },
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('edit-unit')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-unit')
      },
      async addUnit() { 
        this.unitSaving = true;
        let formData = new FormData();
        formData.append("name", this.name);
        let url = "/addproductunit";
        try {
          await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
              this.fetchUnits();
              this.$bvModal.hide('new-unit');
              this.name="";
          }
          });
        } finally {
          this.unitSaving = false;
        }
      },
      async editUnit(){ 
      this.unitEditSaving = true;
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      let url = "/updateproductunit";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchUnits();
            this.$bvModal.hide('edit-unit');
            this.name="";
          }
        });
      } finally {
        this.unitEditSaving = false;
      }
      },
      async removeUnit() { 
      this.unitDeleteSaving = true;
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeproductunit";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchUnits();
            this.$bvModal.hide('delete-unit');
          }
        });
      } finally {
        this.unitDeleteSaving = false;
      }
      },
    },
  };
  </script>

<style scoped>
.app-modal-banner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.app-modal-banner-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #ffffff;
  font-size: 1.1rem;
  box-shadow: 0 8px 18px rgba(20, 184, 166, 0.22);
}

.app-modal-banner-title {
  font-size: 0.92rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.15;
}

.app-modal-banner-sub {
  margin-top: 0.15rem;
  font-size: 0.76rem;
  color: #475569;
  line-height: 1.35;
}

.app-modal-banner-sub i {
  color: #0f766e;
  font-size: 0.95rem;
  vertical-align: -2px;
}

.field-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
  font-size: 0.84rem;
  font-weight: 600;
  color: #1f2937;
}

.help-icon {
  font-size: 1rem;
  color: #94a3b8;
  cursor: help;
  transition: color 0.18s ease, transform 0.18s ease;
}

.help-icon:hover,
.help-icon:focus {
  color: #0f766e;
  transform: translateY(-1px);
  outline: none;
}
</style>

<style>
.app-help-popover.popover {
  max-width: 340px;
  min-width: 280px;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  background: #ffffff;
  font-family: inherit;
}

.app-help-popover .popover-header {
  padding: 0.5rem 0.6rem 0.5rem 0.9rem;
  border-bottom: 1px solid #e2e8f0;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.app-help-popover .popover-body {
  padding: 0.85rem 0.95rem;
  font-size: 0.85rem;
  line-height: 1.55;
  color: #1f2937;
}

.app-help-popover .popover-body strong {
  color: #0f766e;
  font-weight: 700;
}

.app-help-popover-titlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.app-help-popover-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 0;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.app-help-popover-close:hover,
.app-help-popover-close:focus {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.06);
  outline: none;
}

.app-help-popover-close i {
  font-size: 0.95rem;
}

.app-help-popover.bs-popover-right > .arrow::after,
.app-help-popover.bs-popover-auto[x-placement^="right"] > .arrow::after {
  border-right-color: #ffffff;
}

.app-help-popover.bs-popover-right > .arrow::before,
.app-help-popover.bs-popover-auto[x-placement^="right"] > .arrow::before {
  border-right-color: #cbd5e1;
}
</style>
